
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1967"}},[_c('path',{attrs:{"data-name":"Rectangle 2698","fill":"none","d":"M0 0h24v24H0z"}}),_c('path',{attrs:{"data-name":"Path 1293","d":"M1.005 23L1 9a1.126 1.126 0 01.386-.722l10.337-6.892a.566.566 0 01.277-.06.556.556 0 01.278.061l10.335 6.89A1.128 1.128 0 0123 9l-.005 14z","fill":"#f9a36c"}}),_c('path',{attrs:{"data-name":"Path 1294","d":"M23.168 7.445L12.832.554a1.632 1.632 0 00-1.664 0L.832 7.445A2.093 2.093 0 000 9l.005 14a1 1 0 001 1h21.99a1 1 0 001-1L24 9a2.093 2.093 0 00-.832-1.555zM21.995 22H2.005v-5.92h6.019l-2.293 2.293a1 1 0 101.414 1.414l4-4a1 1 0 000-1.414l-4-4a1 1 0 10-1.414 1.414l2.293 2.293h-6.02V9.09l.016-.031 9.984-6.655 9.984 6.655.016.031z"}})])])
          )
        }
      }
    